import { render } from "./PrintInvoiceInfoDesign2.vue?vue&type=template&id=e4676404&scoped=true"
import script from "./PrintInvoiceInfoDesign2.vue?vue&type=script&lang=js"
export * from "./PrintInvoiceInfoDesign2.vue?vue&type=script&lang=js"

import "./PrintInvoiceInfoDesign2.vue?vue&type=style&index=0&id=e4676404&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e4676404"]])

export default __exports__